const ASSIGNMENTS_UPDATE_INTERVAL = 60000;
const LESSON_REDIRECT_LOADING_SCREEN_DELAY_MS = 3000;
const REALTIME_CALLBACK_TIMEOUT = 2500;
const INSIGHTS_POLLING_INTERVAL = 60000 * 5; // 5 minutes

const hooksConstants = {
  ASSIGNMENTS_UPDATE_INTERVAL,
  LESSON_REDIRECT_LOADING_SCREEN_DELAY_MS,
  REALTIME_CALLBACK_TIMEOUT,
  INSIGHTS_POLLING_INTERVAL,
};
export default hooksConstants;
